import { Type } from 'class-transformer';
import { GradPlanOverviewModel } from './grad-plan-overview.model';

export type GradPlanRequirementType =
	| 'course'
	| 'subject_area'
	| 'course_completion';

export class GradPlanRequirementModel {
	requirement_id: number;
	requirement_title: string;
	requirement_type: GradPlanRequirementType;
	credits: number;
	subject_id: number;
	course_ids: number[];
	base_subject_ids: number[];
}

export function GradPlanRequirementModel_ClassTransform_Type() {
	return GradPlanRequirementModel;
}

export class GradPlanDetailModel extends GradPlanOverviewModel {
	program_ids: number[];
	@Type(GradPlanRequirementModel_ClassTransform_Type)
	requirements: GradPlanRequirementModel[];
}
